/**
 * Edit CTABlock Edit.
 * @module components/Blocks/CTABlock/Edit
 *
 * Customizzations:
 * - path for Sidebar and Block
 *
 */

import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import Sidebar from './Sidebar';
import BodyWrapper from 'design-comuni-plone-theme/components/ItaliaTheme/Blocks/CTABlock/BodyWrapper.jsx';
import Block from './Block';

class Edit extends React.Component {
  render() {
    return (
      <>
        <BodyWrapper inEditMode={true}>
          <Block {...this.props} inEditMode={true} />
        </BodyWrapper>

        <SidebarPortal selected={this.props.selected || false}>
          <Sidebar {...this.props} />
        </SidebarPortal>
      </>
    );
  }
}

export default Edit;
